import { IsEnum } from 'class-validator';

import { ReactionTypeEnum } from '@onArte/shared/database/enums';

export class ReactionTypeModel {
  @IsEnum(ReactionTypeEnum)
  public type: ReactionTypeEnum;
}
